import axios from "@/libs/api.request";
export const getList = params => {
  return axios.request({
    url: "/finance/DblCostRule",
    method: "GET",
    params
  });
};
export const getDetails = id => {
  return axios.request({
    url: `/finance/DblCostRule/${id}`,
    method: "GET"
  });
};
export const del = id => {
  return axios.request({
    url: `/finance/DblCostRule/${id}`,
    method: "DELETE"
  });
};
export const update = data => {
  return axios.request({
    url: `/finance/DblCostRule/${data.id}`,
    method: "PUT",
    data
  });
};
export const add = data => {
  return axios.request({
    url: "/finance/DblCostRule",
    method: "POST",
    data
  });
};
export const getRule = airwayNumber => {
  return axios.request({
    url: `/finance/DblCostRule/getRule/${airwayNumber}`,
    method: "GET"
  });
};